export default __webpack_public_path__ + "static/media/licenses.e255b65b.txt";